import { GET_PROJECT_MONITOR } from './actionTypes'

export const ProjectMonitorAction = (projectMonitor) => ({
  type: GET_PROJECT_MONITOR,
  projectMonitor,
})


